<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Monitor from '@/services/Monitor';
import modalAddEnvConfigDefinition from '@/components/modals/application/modalAddEnvConfigDefinition';
import modalEditEnvConfigDefinition from '@/components/modals/application/modalEditEnvConfigDefinition';
import Swal from "sweetalert2";

export default {
  components: {Layout, PageHeader, modalAddEnvConfigDefinition, modalEditEnvConfigDefinition},
  page: {
    title: "Environment Configuration Definitions",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  created() {
    this.getEnvConfigDefinition()
  },
  computed: {
    filteredTableData() {
      let items = this.tableData;

      if (this.selectedGroup) {
        items = items.filter(item => item.group === this.selectedGroup);
      }

      return this.filterItems(items, this.filter);
    },

    paginationTotalRows() {
      return this.filteredTableData.length;
    },
  },
  watch: {
    selectedGroup() {
      this.currentPage = 1;
    },
    filter() {
      this.currentPage = 1;
    },
  },
  methods: {
    filterItems(items, searchTerm) {
      const search = (searchTerm || '').trim().toLowerCase();
      if (!search) {
        return items;
      }

      return items.filter(item =>
        Object.values(item).some(
          val => val != null && String(val).toLowerCase().includes(search)
        )
      );
    },

    modalAddNewEnvConfigDefinition() {
      this.$bvModal.show("add_new_env_config_definition")
    },

    modalEditConfigDefinition(definitionData = {}){
      this.definitionData = definitionData
      this.$bvModal.show("edit_config_definition")
    },

    getEnvConfigDefinition() {

      this.tableData = []
      this.totalRows = 0
      this.currentPage = 1
      this.isBusy = true

      Monitor.getEnvConfigDefinition()
          .then((response) => {
            const data = response.data.data

            this.tableData = response.data.data
            this.totalRows = this.tableData.length
            this.isBusy = false;

            // Unique groups
            this.configGroups = [...new Set(this.tableData.map(item => item.group))];

            // Unique keys
            this.configKeys = [...new Set(this.tableData.map(item => item.key))];

            this.configDefinitions = data
          })
          .catch(error => {

            this.configKeys = []
            this.configDefinitions = []
          })
    },

    removeDBConfig(data) {
      Swal.fire({
        title: "Remove key " + data.key + " for tenant " + this.currentTenant +"?",
        text: "Remove key!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          Monitor.removeEnvConfig(data.key, this.currentTenant)
              .then((response) => {
                const res = response.data.data || false;
                const error = response.data.error || '';
                if (!res && !error) {
                  this.refreshData();
                  this.successmsg("Environment Configuration Key Successfully Removed");
                } else {
                  this.failedmsg("Environment Configuration Key Removal Failed");
                }
              })
              .then((response) => {
                  this.refreshData();
                  this.successmsg("Environment Configuration Key Successfully Removed");
              })
              .catch((error) => {
                this.failedmsg('Fail!', error);
              });
        }
      });
    },

    refreshData(){
      this.getEnvConfigDefinition()
    },

  },
  data() {
    return {
      title: "Environment Configuration Definitions",
      items: [
        {
          text: "Application",
          href: "/application",
        },
        {
          text: "Environment Configuration Definitions",
          active: true,
        },
      ],
      isBusy: false,
      error: null,
      showModal: false,
      modalData: {},
      selectedGroup: '',
      configGroups: [],
      configKeys: [],
      configDefinitions: [],
      definitionData: [],
      tableData: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "key",
      sortDesc: false,
      fields: [
        {
          key: "key",
          label: "Key",
          sortable: false,
        },
        {
          key: "group",
          label: "Group",
          sortable: true,
        },
        {
          key: "type",
          label: "Type",
          sortable: false,
        },
        {
          key: "tenant_required",
          label: "Tenant Required",
          sortable: false,
        },
        {
          key: "common_required",
          label: "Common Required",
          sortable: false,
        },
        {
          key: "is_secret",
          label: "Is Secret",
          sortable: false,
        },
        {
          key: "description",
          label: "Description",
          sortable: false,
        },
        {
          key: "action",
          label: "Action",
          sortable: false,
        },
      ],
    };
  },
  middleware: "authentication",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-2 align-items-end">

              <!-- Group -->
              <div class="col-md-3 mb-3">
                <label class="form-label">Filter By Group</label>
                <select class="form-select"
                        v-model="selectedGroup"
                >
                  <option value="">Select Group</option>
                  <option v-for="group in configGroups"
                          :key="group"
                          :value="group">
                    {{ group }}
                  </option>
                </select>
              </div>

              <!-- Buttons -->
              <div class="col-md-6 mb-3">
                <div class="d-flex gap-2 justify-content-start flex-wrap">

                  <button type="button"
                          class="btn btn-success waves-effect waves-light"
                          @click="modalAddNewEnvConfigDefinition">
                    <i class="mdi mdi-plus me-2"></i>
                    Add New Config Definition
                  </button>

                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">

                <div class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <div class="row">
              <div class="col-sm-12">
                <div class="table-responsive mb-0">
                  <b-table
                      :busy="isBusy"
                      :items="filteredTableData"
                      :fields="fields"
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      show-empty
                      empty-text="No Data Found"
                  >

                    <template v-slot:cell(tenant_required)="data">
                      <span v-if="data.item.tenant_required == '1'" class='font-size-14'>Yes</span>
                      <span v-else class='font-size-14'>No</span>
                    </template>

                    <template v-slot:cell(common_required)="data">
                      <span v-if="data.item.common_required == '1'" class='font-size-14'>Yes</span>
                      <span v-else class='font-size-14'>No</span>
                    </template>

                    <template v-slot:cell(is_secret)="data">
                      <span v-if="data.item.is_secret == '1'" class='font-size-14'>Yes</span>
                      <span v-else class='font-size-14'>No</span>
                    </template>

                    <template v-slot:cell(action)="data">
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item">
                          <a href="javascript:void(0);" class="px-2 text-primary" title="Edit Config Definition"
                             @click="modalEditConfigDefinition(data.item)">
                            <i class="uil uil-pen font-size-18"></i>
                          </a>
                        </li>

                      </ul>
                    </template>

                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>

                  </b-table>

                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="paginationTotalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>

    <!-- MODALS -->
    <modalAddEnvConfigDefinition @onRefresh="refreshData" :configGroups="configGroups" :configKeys="configKeys" :configDefinitions="configDefinitions"></modalAddEnvConfigDefinition>
    <modalEditEnvConfigDefinition @onRefresh="refreshData" :definitionData="definitionData" :configKeys="configKeys" :configGroups="configGroups" :configDefinitions="configDefinitions"></modalEditEnvConfigDefinition>
    <!-- /MODALS -->

  </Layout>
</template>
